import { Component, Input, Pipe, PipeTransform, ViewChild } from '@angular/core';
import { EDeviceType } from '@app/shared/common/enums';
import { ApplicantDetailBehaviorCommunicationService } from '@app/vinter/services/applicant-detail-behavior-analysis-communation.service';
import { ApplicationStepService } from '@app/vinter/services/application-step.service';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'app-behavioral-analysis-section',
  templateUrl: './behavioral-analysis-section.component.html',
  styleUrls: ['./behavioral-analysis-section.component.scss']
})
export class BehavioralAnalysisSectionComponent {
  @Input() item: any;
  @Input() applicationId: any;
  @Input() activeIndex: any;

  @ViewChild('op') op!: OverlayPanel;

  DeviceTypeEnum = EDeviceType;
  backGroundVisible = false;
  applicationSteps: any
  constructor(private applicationStepService: ApplicationStepService,
    private applicantDetailBehaviorCommunicationService : ApplicantDetailBehaviorCommunicationService,
  ) { }

  ngOnInit(): void {
    this.applicantDetailBehaviorCommunicationService.tabUpdate$.subscribe(() => {
      this.UpdateApplicationStepsBehavioralAnalysis(0);
  });
  }

  UpdateApplicationStepsBehavioralAnalysis(activeIndex) {
    if (this.applicationId ?? false) {
      this.activeIndex = activeIndex;
      this.applicationStepService.GetApplicationStepsForApplicantDetail({ applicationId: this.applicationId }).subscribe({
        next: (result) => {
          this.applicationSteps = result;
          this.applicationSteps.sort((a, b) => a.order - b.order);
          let stepId = this.item.id;
          const filteredSteps = this.applicationSteps.filter(step => step.id === stepId);
          if (filteredSteps.length) {
            this.item = filteredSteps[0];
          }
        }
      });
    }
  }

  handleMouseOver(event: MouseEvent): void {
    this.setBackgroundDarkness(true);
    this.op.show(event);
  }

  handleMouseOut(): void {
    this.op.hide();
    this.setBackgroundDarkness(false);
  }

  setBackgroundDarkness(event: boolean) {
    this.backGroundVisible = event;
  }

}

@Pipe({
  name: 'deviceTypes',
})
export class DeviceTypesPipe implements PipeTransform {
  transform(row: any, list: any[]): any {
    return list.find(x => x.id === row).name;
  }
}
